import { Eye } from "lucide-react";
import { Milestone } from "../../../../../Redux/referral/types";
import {
  earningsStatusClass,
  formatEarningsDate,
  statusLabel,
} from "../../earningsAdapters";

interface Props {
  milestones: Milestone[];
  orderNo: string;
  orderDetails?: {
    orderDate?: string;
    orderDateRaw?: string;
    productName?: string;
    orderNo?: string;
  };
}

const ReffCommTeamTable = ({ milestones, orderNo, orderDetails }: Props) => {
  return (
    <div className="ri-table-wrap ri-flow-network-table-wrap">
      <table className="ri-table ri-flow-network-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>DATE</th>
            <th>PRODUCT DETAILS</th>
            <th>MILESTONE</th>
            <th>CONTRIBUTION REQUIREMENT</th>
            <th>ACTIVE CONTRIBUTORS</th>
            <th>STATUS</th>
            <th>NETWORK VIEW</th>
          </tr>
        </thead>
        <tbody>
          {milestones?.map((milestone, index) => {
            const lvl =
              milestone.milestoneNo || (milestone as any).level || index + 1;
            return (
              <tr key={index}>
                <td className="ri-center">
                  <strong>{index + 1}</strong>
                </td>
                <td className="ri-center">
                  <strong>
                    {formatEarningsDate(
                      orderDetails?.orderDateRaw || orderDetails?.orderDate,
                    )}
                  </strong>
                </td>
                <td>
                  <div className="ri-product-copy">
                    <strong>
                      {milestone.productName ||
                        orderDetails?.productName ||
                        "—"}
                    </strong>
                    <span>Order No: {orderDetails?.orderNo || orderNo}</span>
                  </div>
                </td>
                <td className="ri-center">
                  <strong>
                    {milestone.milestoneName || `Level ${lvl} Milestone`}
                  </strong>
                </td>
                <td className="ri-center">
                  <strong>{milestone.contributionRequirement}</strong>
                </td>
                <td className="ri-center">
                  <strong>{milestone.activeContributors}</strong>
                </td>
                <td className="ri-center">
                  <span className={earningsStatusClass(milestone.status)}>
                    {statusLabel(milestone.status)}
                  </span>
                </td>
                <td className="ri-center">
                  <a
                    className="ri-view-button"
                    href={`/ReferralCommLevel?orderNo=${orderNo}&milestoneNo=${lvl}`}
                  >
                    View
                    <Eye size={16} />
                  </a>
                </td>
              </tr>
            );
          })}
          {(!milestones || milestones.length === 0) && (
            <tr>
              <td colSpan={8} className="ri-center">
                No milestone data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReffCommTeamTable;
